<template functional lang="pug">
f-model.f-tags(
  model='Attachment_tag'
  collection='Attachment_tag'
  v-bind='data.attrs'
  v-on='listeners'
)
</template>

<script lang="js">
import FModel from './f-model'

export default {
  name: 'TagsField',
  mixins: [],
  components: { FModel },
  props: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style lang="scss">
.f-tags {

}
</style>
